export function ellipsize(text: string, max = 25) {
  return text.length > max ? `${text.slice(0, max)}...` : text;
}
